import { get } from 'lodash-es';

import {ActivatedRoute, UrlSerializer, UrlTree} from "@angular/router";
import {AppState, getUserState} from "../../ngrx/app.reducres";

import { Injectable } from '@angular/core';
import {LoginConfig} from "../../login/login.config";
import {Store} from "@ngrx/store";
import {environment} from "../../../environments/environment";
import {take} from 'rxjs/operators';

@Injectable()
export class UrlService {

  constructor(private _store: Store<AppState>,  private _activatedRoute: ActivatedRoute,
              private _urlSerializer: UrlSerializer) { }

  /**
   * This shared-method is responsible for parsing the relevant data from the Url and response with it.
   *
   * @returns {
   *    redirectQp,
   *    isRedirectedFromReachOut,
   *    errorQp,
   *    sfQp,
   *    appQp,
   *    dataQp,
   *    isRedirectedFromSFNA,
   *    isRedirectedFromZi,
   *    isRedirectedFromDozi,
   *    isLoginInNewTab
   *    isReachoutSignin
   * }
   * **/
  getInfoFromUrl() {
    const redirectQp = this.getRedirectQpWithPendoParams();
    const isReachout = get(this._activatedRoute, 'snapshot.queryParams.isReachout', '') === 'true';
    const isEngageExt = get(this._activatedRoute, 'snapshot.queryParams.isEngageExt', '') === 'true';
    const isOutlookExt = get(this._activatedRoute, 'snapshot.queryParams.isOutlookExt', '') === 'true';
    const isRedirectFromOutlook = isOutlookExt ? this.getRedirectForOutlook() : '';
    const {isRedirectedFromDevApp, isRedirectedFromReachOut, isRedirectedFromDoziReachOut, isRedirectedFromZiReachOut, isRedirectedFromSFNA, isRedirectedFromMDNA, isRedirectedFromZi, isRedirectedFromDozi, isRedirectedFromRecruiter, isRedirectedFromMarketingCloud, isRedirectedFromZIBackOffice, isRedirectedFromExtension, isRedirectForEngageExt, isRedirectedFromAdmin, isRedirectedFromZiLite, isRedirectedFromEssentials, isRedirectedFromDataPlatform, isRedirectedFromDevPortal, isRedirectedFromGtmCopilot, isRedirectedFromCombinedPlatform, isRedirectedFromTalentEngine, isRedirectedFromBuilder} = this.getRedirectUrlInfo(redirectQp, isReachout, isEngageExt);
    const errorQp = get(this._activatedRoute, 'snapshot.queryParams.error', '');
    const sfQp = get(this._activatedRoute, 'snapshot.queryParams.sf', '');
    const appQp = get(this._activatedRoute, 'snapshot.queryParams.app', '');
    const dataQp = get(this._activatedRoute, 'snapshot.queryParams.data', '');
    const provisionQp = get(this._activatedRoute, 'snapshot.queryParams.provision', false);
    const toggleFromQp = get(this._activatedRoute, 'snapshot.queryParams.toggleFrom', '');
    const toggleToQp = get(this._activatedRoute, 'snapshot.queryParams.toggleTo', '');
    const toggleFromUrlQp = get(this._activatedRoute, 'snapshot.queryParams.toggleFromUrl', '');
    const toggleToUrlQp = get(this._activatedRoute, 'snapshot.queryParams.toggleToUrl', '');
    const toggleFlowErrorQp = get(this._activatedRoute, 'snapshot.queryParams.toggleFlowError', '');
    const autoLoginQp = get(this._activatedRoute, 'snapshot.queryParams.autoLogin', '');
    const uuidTokenQp = get(this._activatedRoute, 'snapshot.queryParams.uuidToken', '');
    const userIdQp = get(this._activatedRoute, 'snapshot.queryParams.userId', '');
    const toggleFlowQp = get(this._activatedRoute, 'snapshot.queryParams.toggleFlow', '');
    const loginUserQpUc = get(this._activatedRoute, 'snapshot.queryParams.loginUser', 0);
    const loginUserQpLc = get(this._activatedRoute, 'snapshot.queryParams.loginuser', 0);
    const oauthLoginErrorLegacyQp = get(this._activatedRoute, 'snapshot.queryParams.OAuthLoginError', '');
    const oauthLoginErrorQp = get(this._activatedRoute, 'snapshot.queryParams.oauthLoginErr', '');
    const utmCampaign = get(this._activatedRoute, 'snapshot.queryParams.utm_campaign', '');
    const ziReferrer = get(this._activatedRoute, 'snapshot.queryParams.ziReferrer', '');
    const loginAsMultiPlatforms = get(this._activatedRoute, 'snapshot.queryParams.loginAsMultiPlatforms', '');
    const domain = window.location.hostname;
    const isLziLoginSubdomain = domain && domain.includes(LoginConfig.LEGACY_LOGIN_URL_IDENTIFIER);
    const isLoginInNewTab = get(this._activatedRoute, 'snapshot.queryParams.newtab', '') === 'true';
    const isReachoutSignin = get(this._activatedRoute, 'snapshot.queryParams.isReachoutSignin', '') === 'true';
    const isRedirectedFromNativePlugin = redirectQp && redirectQp.includes(LoginConfig.NATIVE_PLUGIN_PREFIX_URL);
    const clientId = get(this._activatedRoute, 'snapshot.queryParams.client_id', '');
    const redirectUri = get(this._activatedRoute, 'snapshot.queryParams.redirect_uri', '');
    const codeChallenge = get(this._activatedRoute, 'snapshot.queryParams.code_challenge');
    const codeChallengeMethod = get(this._activatedRoute, 'snapshot.queryParams.code_challenge_method');
    const responseType = get(this._activatedRoute, 'snapshot.queryParams.response_type');
    const scopes: string | null = get(this._activatedRoute, 'snapshot.queryParams.scope') || get(this._activatedRoute, 'snapshot.queryParams.scopes');
    const isMcp = get(this._activatedRoute, 'snapshot.queryParams.is_mcp') === 'true' || !!scopes?.match?.(/zi_mcp/i);  // ZI MCP
    const state = get(this._activatedRoute, 'snapshot.queryParams.state');
    const isDesktopLogin = get(this._activatedRoute, 'snapshot.queryParams.isDesktopLogin') === 'true';
    const isGtmcLogin = get(this._activatedRoute, 'snapshot.queryParams.isGtmcLogin') === 'true';  // ZI Chat App
    const oauthSignupErr = get(this._activatedRoute, 'snapshot.queryParams.oauthSignupErr', '');
    const signupSuccess = get(this._activatedRoute, 'snapshot.queryParams.signup_success') === 'true';
    const signupVendor = get(this._activatedRoute, 'snapshot.queryParams.signup_vendor', '');

    return {
      redirectQp,
      isRedirectedFromDoziReachOut,
      isRedirectedFromZiReachOut,
      isRedirectedFromReachOut,
      errorQp,
      sfQp,
      appQp,
      dataQp,
      isRedirectedFromSFNA,
      isRedirectedFromMDNA,
      isRedirectedFromZi,
      isRedirectedFromDozi,
      isRedirectedFromRecruiter,
      isRedirectedFromMarketingCloud,
      isRedirectedFromZIBackOffice,
      isRedirectedFromDevApp,
      isRedirectedFromExtension,
      isRedirectedFromDevPortal,
      isRedirectedFromGtmCopilot,
      isRedirectedFromCombinedPlatform,
      provisionQp,
      toggleFromQp,
      toggleToQp,
      toggleFromUrlQp,
      toggleToUrlQp,
      toggleFlowErrorQp,
      autoLoginQp,
      uuidTokenQp,
      userIdQp,
      toggleFlowQp,
      loginUserQp: loginUserQpUc || loginUserQpLc,
      oauthLoginErrorLegacyQp,
      oauthLoginErrorQp,
      utmCampaign,
      isReachout,
      ziReferrer,
      loginAsMultiPlatforms,
      isLziLoginSubdomain,
      isEngageExt,
      isRedirectForEngageExt,
      isRedirectFromOutlook,
      isRedirectedFromAdmin,
      isRedirectedFromZiLite,
      isRedirectedFromEssentials,
      isRedirectedFromDataPlatform,
      isRedirectedFromTalentEngine,
      isRedirectedFromBuilder,
      isLoginInNewTab,
      isReachoutSignin,
      isRedirectedFromNativePlugin,
      clientId,
      redirectUri,
      codeChallenge,
      codeChallengeMethod,
      responseType,
      scopes,
      isMcp,
      state,
      isDesktopLogin,
      isGtmcLogin,
      oauthSignupErr,
      signupSuccess,
      signupVendor,
    };
  }

  /**
   * This method is responsible for the final redirectUrl logic.
   *
   * Redirect QP is editable by the user therefore we're validating it
   *
   *
   * **/
  getLoginFinalRedirectUrl() {
    let userState;
    this._store.select(getUserState).pipe(take(1)).subscribe((user) => userState = user);
    //
    const redirectUrlOnState = get(userState, 'redirectUrl');
    //
    return redirectUrlOnState;
  }

  getRedirectForOutlook() {
    return environment.engage_url_enterprise + LoginConfig.OUTLOOK_POSTFIX_URL;
  }

  getRedirectUrlInfo(redirectUrl = '', isReachout = false, isEngageExt = false) {
    const isRedirectedFromDevApp = this.getUrlValue(redirectUrl, 'dev.zoominfo.com');
    //
    const isRedirectedFromSFNA = this.getUrlValue(redirectUrl, LoginConfig.SFNA_PREFIX_URL);
    const isRedirectedFromMDNA = this.getUrlValue(redirectUrl, LoginConfig.MDNA_PREFIX_URL);
    const isRedirectedFromNativePlugin = this.getUrlValue(redirectUrl, LoginConfig.NATIVE_PLUGIN_PREFIX_URL);
    //
    const isRedirectedFromZi = this.getUrlValue(redirectUrl, environment.zi_url_community) || this.getUrlValue(redirectUrl, environment.zi_url_enterprise);
    const isRedirectedFromDozi = this.getUrlValue(redirectUrl, environment.dozi_url_community) ||
                                  this.getUrlValue(redirectUrl, environment.dozi_url_enterprise) ||
                                  this.getUrlValue(redirectUrl, environment.dozi_regression_url);
    const isRedirectedFromRecruiter = this.getUrlValue(redirectUrl, environment.recruiter_url_community) || this.getUrlValue(redirectUrl, environment.recruiter_url_enterprise);

    const isRedirectedFromMarketingCloud = this.getUrlValue(redirectUrl, environment.marketing_cloud_url_enterprise);

    const isRedirectedFromZIBackOffice = this.getUrlValue(redirectUrl, environment.zi_backoffice_url);
    const isRedirectedFromZiLite = this.getUrlValue(redirectUrl, environment.zi_lite_url) || this.getUrlValue(redirectUrl, environment.zi_lite_regression_url);
    const isRedirectedFromEssentials = this.getUrlValue(redirectUrl, environment.essentials_url) || this.getUrlValue(redirectUrl, environment.essentials_regression_url);
    const isRedirectedFromDataPlatform = this.getUrlValue(redirectUrl, environment.partners_url) || this.getUrlValue(redirectUrl, environment.partners_regression_url);
    // ReachOut related
    const isRedirectedFromDoziReachOut = (this.getUrlValue(redirectUrl, LoginConfig.DOZI_REACHOUT_PREFIX_URL) && isRedirectedFromDozi) || isReachout;
    const isRedirectedFromZiReachOut = this.getUrlValue(redirectUrl, LoginConfig.ZI_REACHOUT_PREFIX_URL) && isRedirectedFromZi;
    const isRedirectedFromReachOut = isRedirectedFromDoziReachOut || isRedirectedFromZiReachOut;
    //
    const isRedirectedFromExtension = isRedirectedFromReachOut || isRedirectedFromSFNA || isRedirectedFromMDNA;

    const isRedirectedFromDevPortal = this.getUrlValue(redirectUrl, environment.devportal_domain);
    const isRedirectedFromGtmCopilot = this.getUrlValue(redirectUrl, environment.gtm_copilot_url) || this.getUrlValue(redirectUrl, environment.gtm_copilot_regression_url);
    const isRedirectedFromCombinedPlatform = this.getUrlValue(redirectUrl, environment.combined_platform_url) || this.getUrlValue(redirectUrl, environment.combined_platform_regression_url);
    const isRedirectedFromTalentEngine = this.getUrlValue(redirectUrl, environment.talent_engine_url) || this.getUrlValue(redirectUrl, environment.talent_autopilot_url);
    const shouldUseSecuredCookie = isRedirectedFromDoziReachOut || isRedirectedFromNativePlugin || isRedirectedFromGtmCopilot || isRedirectedFromCombinedPlatform;

    const isRedirectedFromBuilder = this.getUrlValue(redirectUrl, environment.gtm_studio_url);

    // Engage Extension Related
    let isRedirectForEngageExt = isEngageExt ? environment.engage_url_enterprise + LoginConfig.ENGAGE_EXT_POSTFIX_URL : '';
    if (this.isEngageExtensionOnGmail() && !!isRedirectForEngageExt) {
      isRedirectForEngageExt += LoginConfig.ENGAGE_EXT_GMAIL_POSTFIX;
    }

    //Admin Portal
    const isRedirectedFromAdmin = this.getUrlValue(redirectUrl, environment.admin_url_enterprise) || this.getUrlValue(redirectUrl, environment.admin_regression_url);

    return {
      isRedirectedFromDevApp,
      isRedirectedFromDoziReachOut,
      isRedirectedFromZiReachOut,
      isRedirectedFromReachOut,
      isRedirectedFromSFNA,
      isRedirectedFromMDNA,
      isRedirectedFromZi,
      isRedirectedFromDozi,
      isRedirectedFromRecruiter,
      isRedirectedFromMarketingCloud,
      isRedirectedFromZIBackOffice,
      isRedirectedFromExtension,
      shouldUseSecuredCookie,
      isRedirectForEngageExt,
      isRedirectedFromAdmin,
      isRedirectedFromZiLite,
      isRedirectedFromEssentials,
      isRedirectedFromDataPlatform,
      isRedirectedFromDevPortal,
      isRedirectedFromGtmCopilot,
      isRedirectedFromCombinedPlatform,
      isRedirectedFromTalentEngine,
      isRedirectedFromBuilder,
    };
  }
  /**
   * Figure out if the provided URL is one of Zoom's application's domain
   * **/
  isUrlAllowedForRedirect(url) {
    if (url) {
      try {
        const hostname = new URL(url).hostname;
        return LoginConfig.ALLOWED_REDIRECT_URL_HOSTNAMES.some((allowedHostname) => hostname.endsWith(allowedHostname));
      } catch (err) {
        console.error('ERROR in isUrlAllowedForRedirect :: ', err);
      }
    }
    return false;
  }

  /**
   * Method to return Boolean value for redirect Url
   * @param redirectUrl
   * @param url
   * @private
   */
  getUrlValue(redirectUrl: string, url: string) {
    return redirectUrl && redirectUrl.includes(url);
  }

  /**
   * checks if extension is running om gmail domain
   * this is required for engage extension to redirect back
   * Engage extension supports Gmail and we specifically set a redirection for gmail
   */
  isEngageExtensionOnGmail() {
    const gmailUrls = ['https://mail.google.com', 'https://inbox.google.com'];
    if (gmailUrls.indexOf(window.location.origin) !== -1) {
      return true;
    } else {
      return false;
    }
  }

  /** If the url is from Skilljar, return the params. If not, return null. */
  static getSkilljarUrlParams(url: string) {
    const searchParams = new URLSearchParams(url);
    const SAMLRequest = searchParams.get('SAMLRequest');
    const RelayState = searchParams.get('RelayState');
    const Signature = searchParams.get('Signature');
    const SigAlg = searchParams.get('SigAlg');
    if (decodeURI(url).includes(environment.skilljarUrlPartial) && SAMLRequest && RelayState && Signature && SigAlg) {
      return { SAMLRequest, RelayState, Signature, SigAlg };
    }
    return null;
  }

  /**
   * Check if the current request is from MCP OAuth flow
   * When redirect_uri contains MCP domains, the login flow should not redirect to mobile/download app page
   */
  static isFromMcpOAuthFlow(queryStr): boolean {
    const searchParams = new URLSearchParams(queryStr);
    const isMcp = searchParams.get('is_mcp');
    return isMcp?.toLowerCase() === 'true';
  }

  /**
   * Check if the URL path contains the path for Partners password reset URL.
   */
  static isPartnersPwResetUrl(url: string): boolean {
    return url.includes(LoginConfig.PARTNERS_SETUP_PASSWORD_PAGE_PATH);
  }

  getRedirectQpWithPendoParams(): string {
    const redirectQp = get(this._activatedRoute, 'snapshot.queryParams.redirect', '') as string;
    return this.appendAllowedQueryParamsToUrl(redirectQp);
  }

  appendAllowedQueryParamsToUrl(baseUrl: string, paramNames: string[] = LoginConfig.PENDO_ALLOWED_QUERY_PARAMS): string {
    const allowedParams = this.getAllowedQueryParams(paramNames);

    if (!baseUrl || allowedParams.length === 0) {
      return baseUrl;
    }

    const hashIndex = baseUrl.indexOf('#');
    if (hashIndex !== -1) {
      const fragment = baseUrl.slice(hashIndex);
      const separator = fragment.includes('?') ? '&' : '?';
      return baseUrl.slice(0, hashIndex) + fragment + separator + allowedParams.join('&');
    }

    // No hash — append to the URL's own query string
    const separator = baseUrl.includes('?') ? '&' : '?';
    return baseUrl + separator + allowedParams.join('&');
  }

  /**
   * Re-attaches the builder/GTM signup-context params (goal, useCase, Origin, UseCaseOrigin,
   * builder_type, audience) onto the outgoing redirect URL. Scoped to the gtm-studio
   * (isRedirectedFromBuilder) destination only — see LoginConfig.BUILDER_SIGNUP_CONTEXT_PARAMS.
   */
  appendBuilderContextParamsToUrl(baseUrl: string): string {
    return this.appendAllowedQueryParamsToUrl(baseUrl, LoginConfig.BUILDER_SIGNUP_CONTEXT_PARAMS);
  }

  private getAllowedQueryParams(paramNames: string[]): string[] {
    const queryParams = get(this._activatedRoute, 'snapshot.queryParams', {});
    const allowedParams: string[] = [];
    for (const paramName of paramNames) {
      const value = queryParams[paramName];
      if (value != null && value !== '') {
        allowedParams.push(`${paramName}=${encodeURIComponent(value)}`);
      }
    }
    return allowedParams;
  }


}
